// @flow

type EnvironmentallyFriendlyProps = {
  production: *,
  nonProduction: *,
};

const environmentallyFriendly = ({
  production,
  nonProduction,
}: EnvironmentallyFriendlyProps) =>
  process.env.NODE_ENV === 'production' ? production : nonProduction;

export default environmentallyFriendly;
